export default {
  login: {
    logIn: '立即登录 Sign-In',
    bind: '绑定',
    enterSystem: '进入系统',
    username: '账号名 Account',
    password: '密码 Password',
    any: '随便填',
    accountTit: '账号密码登录',
    useAccountLogin: '使用账号密码登录',
    ForgotPassword: '忘记密码',
    inputTel: '手机号 Tel',
    inputMail: '邮箱 E-mail',
    telOrMail: '手机号/邮箱 Tel/E-mail',
    telOrMailOrAccount: '手机号/邮箱/账号 Tel/E-mail/Account',
    codeTit: '验证码登录',
    code: '验证码 Verification code',
    useCodeLogin: '使用验证码登录',
    getNoCode: '没收到验证码？',
    scanTit: '微信扫码登录',
    account: '账号名 Account',
    newPassword: '新密码 New password',
    confirmPassword: '确认新密码 Confirm password',
    confirm: '确定 Confirm'
  },
  table: {
    noData: '暂无数据'
  },
  common: {
    selectSource: '选择数据源',
    selectMonth: '选择月份'
  },
  onlineReport: {
    onlineReport: '在线报告', // 'Online report',
    projectReport: '项目报告', // 'Project report',
    publicReport: '公开报告', // 'Public report',
    planReport: '计划书', // 'Proposal',
    topicReport: '专题报告', // 'Topic report',
    conditions: '条件筛选', // 'Conditions',
    reportName: '报告名称', // 'Report name',
    reportType: '报告类型', // 'Report type',
    reportLabel: '报告标签', // 'Report label',
    reportForm: '报告格式', // 'Report form',
    reportFrequency: '报告频次', // 'Report frequency',
    reportMode: '报告模式', // 'Report mode',
    reportSequence: '报告排序', // 'Report sequence',
    releasedTime: '发布时间', // 'Released time',
    reportIntroduction: '报告简介', // 'Report introduction',
    reportPeriod: '报告时间', // 'Report period',
    confirm: '确定', // 'Confirm',
    reset: '重置', // 'Reset',
    to: '至', // 'to',
    all: '全部', // 'All',
    chooseReportType: '报告类型选择', // 'Choose report type',
    choosePeriod: '选择日期', // 'Choose period',
    selected: '已选', // 'Selected',
    reportTypeSubType: '请输入报告类型或子类型名称搜索', // 'Please input report type or sub-type',
    search: '搜索', // 'Search',
    top: '置顶', // 'Top',
    publisher: '发布人', // 'Publisher',
    reportSize: '报告大小', // 'Report size',
    scanTheReport: '浏览报告', // 'Scan the report',
    download: '下载报告', // 'Download',
    freeForLimitedTime: '限时免费', // 'Free for a limited time',
    left: '剩余', // 'left',
    day: '天', // 'day',
    hour: '时', // 'hour',
    second: '秒', // 'second',
    saySth: '说点什么~', // 'Say sth…',
    endOfPreview: '预览结束', // 'End of preview',
    tipPagesNotRead: '页数限制提示', // 'pages not read. If you want to get more information or buy this report, Please contact 020-83912326',
    like: '点赞', // 'Like',
    comment: '点评', // 'Comment',
    send: '点评一下', // 'Send',
    commentSucceded: '点评成功，感谢您的宝贵意见！', // 'Comment succeded. Thank you.',
    select: '请选择', // 'Select',
    enterKeywordsSearch: '请输入关键字进行搜索', // 'Please enter keywords to search',
    startingTime: '开始时间', // 'Starting time',
    endTime: '结束时间', // 'End Time',
    contactToBuy: '联系购买', // 'Contact to buy',
    makePurchase: '联系购买提示', // 'Please contact Wilson 020-83912326 to make a purchase, you can view after purchase',
    pleaseWait: '下载中提示', // 'Please wait, downloading ...',
    tipoperationFailed: '操作失败提示', // 'Operation failed, please contact the developer!',
    tipNotSupportBrowsing: '不支持浏览提示', // 'The report does not support browsing, please check it by purchasing and downloading!',
    noData: '暂无数据', // 'No Data',
    applyForAuthorization: '申请授权', // 'Apply for authorization',
    forMoreInformation: '申请授权提示', // 'This report needs to apply for authorization. For more information, please contact Wilson 020-83912326'
    totalItems: '共 {count} 条', // 'Total {count} items'
    previous: '上一页', // 'Previous'
    next: '下一页', // 'Next'
    freeLimitedTime: '限时免费', // 'Free for a limited time'
    default: '默认', // 'Default'
    informationOverview: '信息概览' // 'Information overview'
  },
  home: {
    welcome: '欢迎登录威尔森智库决策支持系统', //	Welcome to i-Analytics decision-making support system
    portal: '快捷入口', //	Portal
    broadOverview: '信息概览', //	Broad Overview
    onlineReport: '在线报告', //	Online Report
    IWminiProgram: 'IW小程序', //	IW mini program
    enterNew: '进入新版', //	Enter the new
    officialWebsite: '平台官网', //	Official website
    enterSystem: '进入系统', //	Enter System
    frequentlyUsed: '经常使用', //	Frequently Used
    announcement: '公告列表', //	Announcement
    basicInformation: '基本信息', //	Basic information
    feedbackResponse: '反馈结果', //	Feedback response
    changePassword: '修改密码', //	Change password
    logOut: '退出登录', //	Log Out
    switchAccount: '切换账号', //	Switch account
    informationOverview: '信息概览', // Information overview
    solutions1: '市场监测', // Market monitoring
    solutions11: '市场扫描', // Market overview
    solutions12: '产品定位检验', // Product position inspection
    solutions2: '竞争力分析', // Competitiveness analysis
    solutions21: '产品竞争力', // Product competitiveness
    solutions22: '价格竞争力', // Price competitiveness
    solutions23: '传播竞争力', // Propagation competitiveness
    solutions24: '品牌竞争力', // Brand competitiveness
    solutions25: '渠道竞争力', // Channel competitiveness
    solutions3: '调整优化', // Adjustment & Optimization
    solutions31: '配置优化策略', // Equipment optimization strategy
    solutions32: '定价策略', // Pricing strategy
    solutions4: '销售机会管理', // Sales opportunity management
    solutions41: '用户画像精准营销', // User portrait marketing
    solutions42: '销售线索智能评级', // Sales clue rating
    solutions5: '用户忠诚度管理', // User loyalty management
    solutions51: '金融服务', // Financial service
    solutions52: '报销服务', // Claim service
    solutions53: '保养服务', // Maintenance service
    solutions54: '车联网服务', // IOV service
    solutions6: '客户关系管理', // Customer relationship management
    solutions61: '车主运营', // Car owner management
    solutions62: '再购推荐', // Purchase recommendation
    solutions7: '总部-区域-经销商运营管理', // Headquarter-region-dealership operation & management
    solutions71: '销售', // Sale
    solutions72: '价值链', // Value chain
    solutions73: '售后', // After-sale
    // no english
    doesNotSupport: '您的浏览器不支持 video 标签。', //	Your browser does not support the video tag.
    returnPortal: '返回快捷入口', //	Back to portal
    IKnow: '我知道了', //	Got it
    scanIWminiProgram: '扫码关注 IW小程序', //	Scan QR code to IW mini program
    accountStatus1: '禁用', //	Disabled
    accountStatus2: '启用', //	Enabled
    accountStatus3: '冻结', //	Frozen
    accountType1: '正式账号', //	Official account
    accountType2: '试用账号', //	Trial account
    accountType3: '内部账号', //	Internal account
    accountType4: '测试账号', //	Test account
    columns1: '机构', //	Institution
    columns2: '账号', //	Account
    columns3: '姓名', //	Name
    columns4: '账号类型', //	Account type
    columns5: '状态', //	Status
    columns6: '有效期', //	Valid to
    switchToAccount: '切换到账号（{name}）', //	Change account（{name}）
    perfectYourPersonalLetter: '新上线用户基本信息页，<br>请尽快完善个人信息。<br>', //	Basic information of new users, <br>please fill in personal information<br>
    pullDownToSwitchAccounts: '下拉可切换账号。', //	Pull to change account
    switchLanguageSuccess: '语言切换成功', //	Language changed
    switchLanguageFail: '语言切换失败', //	Language change failed
    details: '详情', //	Details
    statusName1: '进入', //	Enter
    statusName2: '即将上线', //	Coming soon
    statusName3: '申请试用', //	Apply for test
    statusName4: '不可用', //	Unavailable
    foot1: '官网首页  /  智库  /  智策  /  达示数据  /  加入我们', //	Home page / i-Analytics / i-Solutions / DaaS / Join us
    foot2: '广州威尔森信息科技有限公司' //	Guangzhou WAYS Information Technology Co., Ltd.
  }
}
/*
{{$t('home.a')}}
$t('selectAtMost')
this.$t('tipDownloading')
t['chart']
dateZHandEN({y: a})
(.[\u4E00-\u9FA5]+)|([\u4E00-\u9FA5]+.)
*/



// WEBPACK FOOTER //
// ./src/lang/zh.js